<template>
	<AppHeader
		:title="title"
	/>
	<v-main>
		<router-view/>
	</v-main>
</template>

<script>
import AppHeader from '@/components/base/AppHeader.vue'

export default {

	name: 'UserView',

	components: { AppHeader },

	props: {},

	emits: {},

	data: () => ({

		//data

	}),

	computed: {
        title() {
            const isAppHeaderActive = this.$route.meta.activeHeader

            return isAppHeaderActive ? this.$route.meta.title : ''
        }
    },

	created() {},

	methods: {},

}
</script>

<style lang="scss">

</style>
